<ion-header *ngIf="modal"
            class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ion-title *ngIf="!newsfeed.id"
                   [innerHTML]="'NEWSFEED_CREATE_POST' | translate"></ion-title>
        <ion-title *ngIf="newsfeed.id"
                   [innerHTML]="'NEWSFEED_EDIT_POST' | translate"></ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="backClicked()">
                <ion-icon slot="icon-only"
                          color="dark"
                          name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<form method="post"
      #f="ngForm"
      role="form"
      [ngClass]="{'modal': modal }"
      class="form-horizontal">

    <ion-item [ngClass]="{'has-value': (newsfeed.hasValue() || linkInputVisible || displayBigTextarea) }"
              class="form-content">
        <ion-grid class="ion-no-padding">

            <ion-row class="row-message ion-no-padding"
                     tabIndex="-1"
                     [ngClass]="{'has-error': validate && validationErrors['message']}">

                <ion-col class="ion-no-padding">

                    <small *ngIf="credentialSharing"
                           class="hint">
                        {{ 'CREDENTIAL_SHARING_SKILLSCLUB_HINT' | translate}}
                    </small>

                    <ion-textarea #messageTextarea
                                  ieTextareaFix
                                  placeholder="{{ 'PLACEHOLDER_FEED' | translate }}"
                                  name="message"
                                  inputmode="text"
                                  spellcheck="false"
                                  autocapitalize="off"
                                  id="messageTextarea"
                                  maxLength="1500"
                                  autoGrow="true"
                                  (click)="displayBigTextarea = true"
                                  (ionChange)="newsfeed.initVideoEmbedLink()"
                                  (ionFocus)="plt.checkResize()"
                                  (ionBlur)="plt.checkResize(false)"
                                  [(ngModel)]="newsfeed.message">
                    </ion-textarea>

                    <div class="action-buttons">

                        <ion-spinner *ngIf="sending"
                                     name="dots">
                        </ion-spinner>

                        <div class="action-buttons-wrap"
                             [hidden]="sending">
                            <ng-container *ngIf="plt.is('cordova')">
                                <div class="mobile-image-buttons">
                                    <button class="pure-btn"
                                            (click)="openCamera()">
                                        <ion-icon name="camera"
                                                  color="secondary">
                                        </ion-icon>
                                    </button>
                                    <button class="pure-btn"
                                            (click)="openAlbums()">
                                        <ion-icon name="image"
                                                  color="secondary">
                                        </ion-icon>
                                    </button>
                                </div>
                            </ng-container>

                            <div class="dropzone-video"
                                 [class.hidden]="!(!plt.is('cordova') && !newsfeed.video) || !event?.enable_newsfeed_video || !user?.enable_newsfeed_video">
                                <dropzone #dropzoneVideo
                                          [message]="''"
                                          [config]="dropZoneConfigVideo"
                                          (success)="onUploadSuccess($event, 'video')"
                                          (error)="onUploadError($event, 'video')"
                                          (sending)="onSending($event, false, true)"
                                          (totalUploadProgress)="uploadProgress($event)">
                                </dropzone>
                            </div>

                            <div class="dropzone-image"
                                 [class.hidden]="!(!plt.is('cordova') && !newsfeed.image)">
                                <dropzone #dropzoneImage
                                          [message]="''"
                                          [config]="dropZoneConfig"
                                          (success)="onUploadSuccess($event)"
                                          (error)="onUploadError($event)"
                                          (sending)="onSending($event)"
                                          (totalUploadProgress)="uploadProgress($event)">
                                </dropzone>
                            </div>

                            <div class="dropzone-file"
                                 [class.hidden]="newsfeed.file">
                                <ng-container>
                                    <ion-thumbnail slot="start">
                                        <dropzone #dropzoneFile
                                                  [message]="''"
                                                  [config]="dropZoneConfigExtended"
                                                  (success)="onUploadSuccess($event, 'file')"
                                                  (error)="onUploadError($event, 'file')"
                                                  (sending)="onSending($event, true)"
                                                  (totalUploadProgress)="uploadProgress($event)">
                                        </dropzone>
                                    </ion-thumbnail>
                                </ng-container>
                            </div>

                            <div *ngIf="!linkInputVisible && !newsfeed.link"
                                 (click)="showLinkInput()"
                                 class="link">
                                <svg-icon [applyClass]="true"
                                          src="/assets/icons/ico-link-blue.svg">
                                </svg-icon>
                            </div>

                            <div *ngIf="showKeywords"
                                 (click)="showKeywordsModal()"
                                 class="keywords">
                                <svg-icon [applyClass]="true"
                                          src="/assets/icons/ico-hashtag-blue.svg">
                                </svg-icon>
                            </div>
                        </div>

                    </div>

                </ion-col>

            </ion-row>

            <div class="newsfeed-controls"
                 tabIndex="-1">
                <ion-row class="row-message-error"
                         *ngIf="validate && validationErrors['message']">
                    <ion-col>
                        <span class="error-message textarea">
                            {{ validationErrors['message'] }}
                        </span>
                    </ion-col>
                </ion-row>
                <ion-row class="row-message-error"
                         *ngIf="validate && validationErrors['keywords']">
                    <ion-col>
                        <span class="error-message">
                            {{ validationErrors['keywords'] }}
                        </span>
                    </ion-col>
                </ion-row>

                <ion-row class="ion-no-padding"
                         *ngIf="linkInputVisible || newsfeed.link">
                    <ion-col class="ion-no-padding">
                        <ion-item [ngClass]="{ 'has-error': validate && validationErrors['link'] }">
                            <ion-input type="text"
                                       placeholder="{{ 'PLACEHOLDER_FEED_LINK' | translate }}"
                                       name="link"
                                       inputmode="text"
                                       spellcheck="false"
                                       autocapitalize="off"
                                       #link="ngModel"
                                       (ionChange)="newsfeed.initVideoEmbedLink()"
                                       [(ngModel)]="newsfeed.link">
                            </ion-input>
                        </ion-item>
                        <span *ngIf="validate && validationErrors['link']"
                              class="error-message">
                            {{ validationErrors['link'] }}
                        </span>
                        <ion-item [ngClass]="{ 'has-error': validate && validationErrors['link_name'] }">
                            <ion-input type="text"
                                       placeholder="{{ 'PARTICIPANT_DETAIL_DESC_TYPE_link_name' | translate }}"
                                       name="link_name"
                                       inputmode="text"
                                       spellcheck="false"
                                       autocapitalize="off"
                                       #link_name="ngModel"
                                       [(ngModel)]="newsfeed.link_name">
                            </ion-input>
                        </ion-item>
                        <span *ngIf="validate && validationErrors['link_name']"
                              class="error-message">
                            {{ validationErrors['link_name'] }}
                        </span>
                    </ion-col>
                </ion-row>

                <ion-row class="ion-no-padding"
                         *ngIf="newsfeed.keywords.length">
                    <ion-col class="ion-no-padding">
                        <div class="keyword-list">
                            <ion-label *ngFor="let selectedKeyword of newsfeed.keywordsUnique"
                                       class="keyword">
                                #{{ selectedKeyword.keyword.translate(userLang, event.default_locale).name | cut: 80 }}
                                <ion-spinner *ngIf="selectedKeyword.keyword.loading == column"
                                             name="dots"></ion-spinner>
                            </ion-label>
                        </div>
                    </ion-col>
                </ion-row>

                <ion-row *ngIf="newsfeed.file || newsfeed.image || newsfeed.video || uploading || (newsfeed.video_embed_link && newsfeed.display_video)"
                         class="ion-no-padding">
                    <ion-col class="ion-no-padding">
                        <div class="file-list">

                            <span *ngIf="uploading"
                                  class="uploading">
                                <!-- END :: initial -->
                                <div class="progress-container"
                                     *ngIf="uploading">
                                    <ion-progress-bar *ngIf="uploading"
                                                      [value]="progress"
                                                      [buffer]="buffer">
                                    </ion-progress-bar>
                                </div>
                            </span>
                            <span *ngIf="newsfeed.image"
                                  class="image-link">
                                <img [src]="plt.createSignedLink(newsfeed.image_url)">
                                <div class="remove-image"
                                     (click)="deleteImage();">
                                </div>
                            </span>

                            <span *ngIf="newsfeed.file"
                                  class="file-link">
                                <svg-icon [applyClass]="true"
                                          [src]="'/assets/icons/profile/pdf.svg'">
                                </svg-icon>
                                <span class="file-name">{{ newsfeed.filename }}</span>
                                <span class="remove-file"
                                      (click)="deleteFile()"></span>
                            </span>

                            <ng-container *ngIf="!newsfeed.id && newsfeed.video">
                                <span *ngIf="newsfeed.video_embed_link && newsfeed.display_video"
                                      class="video-wrapper empty">
                                    <span class="remove-video"
                                          (click)="deleteVideo()">
                                    </span>
                                    {{'NEWSFEED_VIDEO_PROCESSING' | trns}}
                                </span>
                            </ng-container>
                            <ng-container *ngIf="newsfeed.id || !newsfeed.video">
                                <span *ngIf="newsfeed.video_embed_link && newsfeed.display_video"
                                      class="video-wrapper">
                                    <span class="remove-video"
                                          (click)="deleteVideo()">
                                    </span>
                                    <iframe [src]="newsfeed.video_embed_link | safe:'resourceUrl'"
                                            frameborder="0"
                                            sandbox="allow-scripts allow-same-origin allow-presentation"
                                            allowfullscreen
                                            allow="autoplay;fullscreen">
                                    </iframe>
                                </span>
                            </ng-container>

                        </div>
                    </ion-col>
                </ion-row>

                <ion-row *ngIf="!modal"
                         class="form-button ion-no-padding">
                    <!-- <ion-col class="ion-no-padding">
                            <span *ngIf="validate && validationErrors['message']"
                                  class="error-message">
                                {{ validationErrors['message'] }}
                            </span>
                        </ion-col> -->

                    <ion-col class="ion-no-padding ion-text-right">
                        <ion-button *ngIf="newsfeed.id"
                                    class="btn-close"
                                    (click)="backClicked(false)">
                            {{ 'BUTTON_CANCEL' | translate }}
                        </ion-button>
                        <ion-button color="primary"
                                    id="post-newsfeed-button"
                                    [disabled]="sending || submit"
                                    (click)="postNewsfeed(f.form.valid)">
                            {{ 'BUTTON_SAVE' | translate }}
                        </ion-button>
                    </ion-col>

                </ion-row>

            </div>

        </ion-grid>
    </ion-item>
</form>

<ion-footer *ngIf="modal">
    <ion-row class="action-buttons two ion-no-padding">
        <ion-col size="6"
                 class="ion-no-padding">
            <ion-button class="btn-close"
                        (click)="backClicked()">
                {{ 'BUTTON_CANCEL' | translate }}
            </ion-button>
        </ion-col>
        <ion-col size="6"
                 class="ion-no-padding">
            <ion-button color="primary"
                        [disabled]="sending || submit"
                        (click)="postNewsfeed(f.form.valid)">
                {{ 'BUTTON_SAVE' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>